module.exports = __webpack_public_path__ + "d8c7515fc5cdc80b1789368274f5d167.png";